import { styled } from "@mui/material/styles";
import { Box, Chip } from "@mui/material";
import { colors } from "../../../theme/theme";

export const ChipsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  flexWrap: "wrap",
  background: "transparent",
  [theme.breakpoints.down(1150)]: {
    justifyContent: "center",
  },
}));

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "selected" && prop !== "noHover",
})(({ theme, selected, noHover }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: selected ? 600 : 500,
  fontSize: "14px",
  borderRadius: "20px",
  backgroundColor: selected ? colors.secondary : colors.iconBg,
  color: selected ? colors.white : colors.primary,
  border: selected
    ? `1px solid ${colors.secondary}`
    : `1px solid ${colors.stroke}`,
  "&:hover": {
    backgroundColor: noHover ? "" : selected ? "#1f2e3e" : colors.headerBg,
  },
}));
